module.exports = __webpack_public_path__ + "img/datascience.0de7128a.svg";